import React, { useState, useMemo, useEffect } from "react";
import { Row, Col } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import TextInput from "../../../custom/components/Text-Input/TextInput.js";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput.js";
import CustomForm from "../../../custom/Forms/CustomForm.js";
import { getRecords, saveRecords } from "../../../services/api.service.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useCreateForm from "../../../custom/Utils/UseCreateFormUtils.js";
import { createPageData } from "./WarehouseFile.js";
import { basicFormData } from "./WarehouseFile.js";
import { validate } from "../../../custom/validations/Validate.js";
import SelectInput from "../../../custom/components/Select-Input/SelectInput.js";
import TextAreaInput from "../../../custom/components/TextArea-Input/TextAreaInput.js";

const WarehouseCreate = () => {
  const navigate = useNavigate();
  const menuType = "warehouse";
  let { id } = useParams();
  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
    warehouseTypeList,
  } = createPageData();
  const [loadingData, setLoadingData] = useState(false);
  const initialPayload = useMemo(() => payload, []);

  const {
    formData,
    setFormData,
    onInputChange,
    formErrors,
    setFormErrors,
    handleSelectChange,
    handleWarehouseTypeSelectChange,
    handleUserSelectChange,
    selectedDropOption,
    selectedDropdownOptions,
    setSelectedDropOption,
    setSelectedWarehouseOption,
    selectedWarehouseOption,
    selectedDropdownOptionsDependent,
    selectedDropdownDependent,
    selectedDropdown,
  } = useCreateForm(
    getEndpoint,
    id,
    initialPayload,
    basicFormData(),
    validationType,
    dependentDropdownData,
    menuType
  );

  const [selectedProject, setSelectedProject] = useState(null);
  const [projectlistOptions, setProjectlistOptions] = useState([]);
  const setSelectedOption = (options, value, setSelected) => {
    const matchedOption = options.find((option) => option.value === value);
    setSelected(
      matchedOption
        ? { label: matchedOption.label, value: matchedOption.value }
        : null
    );
  };
  useEffect(() => {
    if (warehouseTypeList.length) {
      setSelectedOption(
        warehouseTypeList[0].options,
        String(formData.inputData.type),
        setSelectedWarehouseOption
      );
    }
  }, [formData.inputData.type]);

  useEffect(() => {
    if (warehouseTypeList.length) {
      setSelectedOption(
        warehouseTypeList[0].options,
        String(formData.inputData.type),
        setSelectedWarehouseOption
      );
    }
  }, [formData.inputData.type]);

  useEffect(() => {
    getProjectData(formData?.inputData?.project_id);
  }, [formData?.inputData?.project_id]);

  const getProjectData = async (p_id) => {
    try {
      const payload = {
        modelName: "projects",
        whereCondition: {
          is_active: true,
        },
      };
      const responseData = await getRecords(payload, "/getRecords");
      if (!responseData) {
        throw new Error("No response received from server");
      }

      if (responseData?.data && Array.isArray(responseData?.data)) {
        const projectOptions =
          responseData &&
          responseData?.data &&
          responseData?.data?.map((project) => ({
            label: project?.project_name,
            value: project?.id,
          }));

        if (id) {
          projectOptions?.forEach((element) => {
            if (element?.value == p_id) {
              setSelectedProject(element);
            }
          });
        }

        setProjectlistOptions(projectOptions);
      } else {
        throw new Error("Invalid data format received");
      }
    } catch (error) {
      console.error("Error fetching project data:", error);
      toast.error(
        error.message || "Failed to load projects. Please try again later."
      );
    }
  };

  const handleProjectSelectChange = (project) => {
    const selectedValue = project ? project.value : null;

    const fieldError = validate(validationType, {
      project_id: selectedValue,
    });

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      project_id: fieldError.project_id || "",
    }));

    if (selectedValue) {
      setSelectedProject(project);
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          project_id: selectedValue,
        },
      }));
    } else {
      setSelectedProject("");
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          project_id: "",
        },
      }));
    }
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const validationErrors = validate(validationType, formData.inputData);
      if (Object.keys(validationErrors).length > 0) {
        setLoadingData(false);
        setFormErrors(validationErrors);
        return;
      }

      const isCreating = !id;
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));

      const payload = {
        id,
        modelName: initialPayload?.modelName,
        inputData: {
          ...formData.inputData,
          created_by: isCreating
            ? userDetails.id
            : formData.inputData.created_by,
          updated_by: userDetails.id,
        },
      };

      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      if (responseData && responseData.code == 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData?.message ||
            `Error while ${id ? "updating" : "saving"} ${headerName}!`
        );
      }
    } catch (error) {
      console.error("err", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md={6} className="mt-3">
          <SelectInput
            label="Project"
            value={selectedProject}
            onSelect={handleProjectSelectChange}
            options={projectlistOptions}
            classNamePrefix="select2-selection"
            noOptionsMessage={() => "No data found."}
            maxMenuHeight={200}
            asterisk={true}
            isClearable={true}
            customError={formErrors?.project_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="State"
            name="state_id"
            value={selectedDropdown}
            options={selectedDropdownOptions}
            onSelect={handleSelectChange}
            placeholder="Select State"
            parentClassName=""
            selectClassName=""
            labelClassName="form-label"
            parentStyle={{}}
            selectStyle={{}}
            labelStyle={{}}
            size={1}
            noDataMessage="data not found"
            maxMenuHeight={200}
            isClearable={false}
            customError={formErrors.state_id}
            asterisk={true}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="City"
            name="city_id"
            value={selectedDropdownDependent}
            options={selectedDropdownOptionsDependent}
            onSelect={handleSelectChange}
            placeholder="Select city"
            parentClassName=""
            selectClassName=""
            labelClassName="form-label"
            parentStyle={{}}
            selectStyle={{}}
            labelStyle={{}}
            size={1}
            noDataMessage="data not found"
            maxMenuHeight={200}
            isClearable={false}
            customError={formErrors.city_id}
            asterisk={true}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Warehouse Name"
            name="warehouse_name"
            value={formData.inputData.warehouse_name}
            onChange={onInputChange}
            placeholder="Warehouse name"
            inputClassName="form-control "
            labelClassName="form-label"
            autocomplete={"off"}
            customError={formErrors.warehouse_name}
            asterisk={true}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="Warehouse Type"
            name="type"
            value={selectedWarehouseOption}
            options={warehouseTypeList}
            onSelect={handleWarehouseTypeSelectChange}
            placeholder="Warehouse type"
            parentClassName=""
            selectClassName=""
            labelClassName="form-label"
            parentStyle={{}}
            selectStyle={{}}
            labelStyle={{}}
            size={1}
            noDataMessage="data not found"
            maxMenuHeight={200}
            isClearable={false}
            customError={formErrors.type}
            asterisk={true}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextAreaInput
            label="Address"
            name="address"
            value={formData.inputData.address}
            onChange={onInputChange}
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            placeholder="Address"
            parentStyle={{}}
            inputStyle={{}}
            labelStyle={{}}
            validate={true}
            rows={3}
            cols={10}
            maxLength
            minLength
            readOnly={false}
            disabled={false}
            required={false}
            wrap={"soft"}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col lg="12">
          <CheckboxInput
            label="Is Active"
            name="is_active"
            value={formData.inputData.is_active}
            checked={formData.inputData.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
            disabled={false}
            required={false}
            customError={formErrors.is_active}
          />
        </Col>
      </Row>
    </CustomForm>
  );
};
export default WarehouseCreate;
